import Icon from "@rio-cloud/rio-uikit/Icon"
import { FuelType as FuelTypeIcon, getFuelIcon } from "@rio-cloud/rio-uikit/fuelTypeUtils"
import { FormattedMessage } from "react-intl"
import { FormSelect } from "@/components/Form/FormSelect"
import { fuelType } from "@/model/transportation-report/transportation-report"

type fuelTypes = typeof fuelType[number]

const fuelTypeIconKeys: {[key in fuelTypes]: FuelTypeIcon} = {
    DIESEL: "diesel",
    DIESEL_AND_ELECTRIC: "hybrid_diesel",
    ELECTRIC: "electric",
    LIQUID_PROPANE_GAS: "lpg",
    PETROL: "gas",
    PETROL_AND_ELECTRIC: "hybrid_gas"
}

export const FuelType = () => {
    return <div
        className="display-flex gap-20 align-items-center justify-content-center padding-20 bg-lightest">
        <div className="padding-x-20 text-center ">
            <span className="text-size-16 text-color-gray">
                <span className="uikit-icon icon-filling-station text-size-200pct">
                </span>
            </span>
        </div>
        <div className={"flex-basis-100pct"}>
            <FormSelect
                fieldName={"transportDetails.transportMode.fuelType"}
                label={<FormattedMessage id={"fuelType.type"}/>}
                options={fuelType.map(it => ({
                    id: it,
                    label: <>
                        <Icon size='h3' iconName="icon-truck" pairIconName={getFuelIcon(fuelTypeIconKeys[it] || "unknown")} />
                        <FormattedMessage id={`fuelType.type.${it}`}/>
                    </>
                }))}
            />
        </div>
        <div className={"flex-basis-100pct"} />
        <div className={"flex-basis-100pct"} />
    </div>
}

